export const DAYS_OF_WEEK = [
	{
		label: 'Sunday',
		code: 'S',
	},
	{
		label: 'Monday',
		code: 'M',
	},
	{
		label: 'Tuesday',
		code: 'T',
	},
	{
		label: 'Wednesday',
		code: 'W',
	},
	{
		label: 'Thursday',
		code: 'T',
	},
	{
		label: 'Friday',
		code: 'F',
	},
	{
		label: 'Saturday',
		code: 'S',
	},
];

export const MONTHS_GAP_DEFAULT = 40;
export const MONTHS_GAP_DESKTOP = 30;
export const MONTHS_GAP_TABLET_PORTRAIT = 12;

export const VISIBLE_MONTHS_COUNT_DESKTOP = 3;
export const VISIBLE_MONTHS_COUNT_TABLET = 2;
